import { EServiceCategory } from "../constants";
import { AdminTaskResponseDto } from "./task";
import { IPartnerResponseDto } from "./partner";
import { IUserBasicPublicInfo } from "./user";

export enum EPenaltyReason {
  HEALTH_ISSUES = "HEALTH_ISSUES",
  FAMILY_EMERGENCY = "FAMILY_EMERGENCY",
  TRANSPORTATION_ISSUES = "TRANSPORTATION_ISSUES",
  WEATHER_CONDITIONS = "WEATHER_CONDITIONS",
  OTHER = "OTHER",
}

export enum EPenaltyActionStatus {
  APPLIED = "APPLIED",
}

export interface IPenaltyData {
  partner: IPartnerResponseDto;
  user: IUserBasicPublicInfo;
  scheduledAt: number;
  serviceCategory: EServiceCategory;
  serviceType: string;
  createdAt: number;
  city: string;
  reason: string;
  proof: Record<string, any>;
  penalty: number;
  sessionId?: string;
}

export type IPenalty = AdminTaskResponseDto<IPenaltyData>;

